export default "__VITE_ASSET__C7DbDn0J__"